/* Oleassence — cadeaux et paliers configurés dans les métaobjets, version 3.
 * Aucune gratuité n'est créée par ce fichier : conserver les remises Shopify.
 */
(() => {
  'use strict';
  if (window.OleassenceCartRewardsV3) return;

  class RewardsController {
    constructor() {
      this.elements = new Set();
      this.steps = [];
      this.dismissed = new Set();
      this.previouslyClaimed = new Set();
      this.busy = false;
      this.adding = false;
      this.queued = false;
      this.forcedId = null;
      this.root = window.Shopify?.routes?.root || '/';
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency', currency: 'EUR',
      });
      ['cart:refresh', 'cart:updated', 'cart:change'].forEach((name) => {
        window.addEventListener(name, () => this.schedule());
      });
      window.addEventListener('pageshow', () => this.schedule());
      window.addEventListener('focus', () => this.schedule());
      this.subscribeToTheme();
      this.watchTheme();
    }

    subscribeToTheme(attempt = 0) {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.schedule());
      } else if (attempt < 20) {
        setTimeout(() => this.subscribeToTheme(attempt + 1), 250);
      }
    }

    watchTheme() {
      const start = () => {
        this.observer = new MutationObserver((records) => {
          const relevant = records.some((record) => {
            if (record.type === 'attributes') return record.target.matches('cart-drawer');
            return [...record.addedNodes, ...record.removedNodes].some((node) =>
              node.nodeType === 1 && (node.matches('cart-gamification') ||
                node.querySelector('cart-gamification'))
            );
          });
          if (relevant) this.schedule();
        });
        this.observer.observe(document.body, {
          childList: true, subtree: true, attributes: true, attributeFilter: ['class'],
        });
      };
      if (document.body) start();
      else document.addEventListener('DOMContentLoaded', start, { once: true });
    }

    register(element) {
      const source = element.querySelector('[data-oa-rewards-config]');
      if (!source) return;
      try {
        const config = JSON.parse(source.textContent);
        this.steps = (config.steps || []).filter((step) => Number(step.goal) > 0)
          .map((step) => ({ ...step, id: String(step.id), goal: Number(step.goal),
            products: step.products || [] })).sort((a, b) => a.goal - b.goal);
        this.giftLabel = config.giftLabel || 'Cadeau';
        this.currency = config.currency || 'EUR';
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'fr', {
          style: 'currency', currency: this.currency,
        });
        this.elements.add(element);
        this.schedule();
      } catch (error) {
        console.error('Configuration des cadeaux Oleassence :', error);
      }
    }

    schedule(forcedId = null) {
      if (forcedId) this.forcedId = forcedId;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.sync(), 80);
    }

    async request(path, body) {
      const response = await fetch(this.root + path, {
        method: body ? 'POST' : 'GET',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        ...(body ? { body: JSON.stringify(body) } : { cache: 'no-store' }),
      });
      const result = await response.json();
      if (!response.ok || Number(result.status) >= 400 || result.errors) {
        const message = result.description || result.message || result.errors;
        throw new Error(typeof message === 'string' ? message : 'Impossible de mettre à jour le panier.');
      }
      return result;
    }

    sections() {
      const drawer = document.querySelector('cart-drawer');
      const ids = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map((section) => section.id)
        : ['cart-drawer', 'cart-icon-bubble'];
      return { sections: [...new Set(ids)].slice(0, 5), sections_url: window.location.pathname };
    }

    updateTheme(result) {
      const drawer = document.querySelector('cart-drawer');
      const expected = this.sections().sections;
      if (drawer && typeof drawer.renderContents === 'function' &&
          expected.every((id) => result.sections?.[id])) {
        drawer.renderContents(result);
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-gamification', cartData: result });
      }
    }

    matchesProduct(step, item) {
      return step.products.some((product) => String(product.id) === String(item.product_id));
    }

    states(cart) {
  const assigned = new Map();

  return this.steps.map((step) => {
    const isGift = step.products.length > 0;
    const eligible = cart.total_price >= step.goal;
    let picked = false;

    if (isGift) {
      const item = cart.items.find((line) => {
        const tag = line.properties?._oa_reward_step;

        if (tag && tag !== step.id) return false;
        if (!this.matchesProduct(step, line)) return false;

        const quantity = Number(line.quantity) || 0;
        let giftQuantity = 0;

        // Cadeau ajouté depuis le popup.
        if (
          tag === step.id ||
          line.properties?.type === this.giftLabel
        ) {
          giftQuantity = quantity;
        }

        // Produit ajouté manuellement et entièrement offert.
        else if (
          line.final_line_price != null &&
          Number(line.final_line_price) === 0
        ) {
          giftQuantity = quantity;
        }

        // Une unité offerte parmi plusieurs produits identiques.
        else {
          const freeAmount = (
            line.line_level_discount_allocations || []
          )
            .filter((allocation) => {
              const discount = allocation.discount_application;

              return (
                discount?.value_type === 'percentage' &&
                Number(discount.value) === 100 &&
                Number(allocation.amount) > 0
              );
            })
            .reduce(
              (sum, allocation) => sum + Number(allocation.amount),
              0
            );

          if (freeAmount > 0) {
            const unitPrice = Number(
              line.original_price || line.price
            );

            giftQuantity = Math.min(
              quantity,
              unitPrice > 0
                ? Math.max(1, Math.floor(freeAmount / unitPrice))
                : 1
            );
          }
        }

        return (assigned.get(line.key) || 0) < giftQuantity;
      });

      if (item) {
        assigned.set(
          item.key,
          (assigned.get(item.key) || 0) + 1
        );

        picked = true;
      }
    }

    return { ...step, isGift, eligible, picked };
  });
}

    removalUpdates(cart) {
      const updates = {};
      for (const item of cart.items) {
        const tag = item.properties?._oa_reward_step;
        const step = tag
          ? this.steps.find((candidate) => candidate.id === tag)
          : this.steps.find((candidate) => candidate.products.length &&
              item.properties?.type === this.giftLabel && this.matchesProduct(candidate, item));
        // Ne jamais retirer automatiquement un produit ajouté manuellement.
        if (step && this.matchesProduct(step, item) && cart.total_price < step.goal) {
          updates[item.key] = 0;
        }
      }
      return updates;
    }

    async sync() {
      if (!this.steps.length) return;
      if (this.busy || this.adding) { this.queued = true; return; }
      this.busy = true;
      try {
        let cart = await this.request('cart.js');
        const updates = this.removalUpdates(cart);
        if (Object.keys(updates).length) {
          const result = await this.request('cart/update.js', { updates, ...this.sections() });
          this.updateTheme(result);
          cart = result.items && typeof result.total_price === 'number'
            ? result : await this.request('cart.js');
        }
        this.cart = cart;
        this.currentStates = this.states(cart);
        for (const state of this.currentStates) {
          if (!state.eligible || (this.previouslyClaimed.has(state.id) && !state.picked)) {
            this.dismissed.delete(state.id);
          }
        }
        this.previouslyClaimed = new Set(this.currentStates.filter((state) => state.picked).map((state) => state.id));
        this.render();
        const active = this.currentStates.find((state) => state.id === this.openStepId);
        if (this.dialog?.open && (!active || !active.eligible || active.picked)) this.close(false);
        const forced = this.forcedId;
        this.forcedId = null;
        const next = this.currentStates.find((state) => state.isGift && state.eligible && !state.picked &&
          (forced ? state.id === forced : !this.dismissed.has(state.id)));
        if (next && (!this.dialog?.open || forced)) this.open(next);
      } catch (error) {
        console.error('Actualisation des cadeaux Oleassence :', error);
        if (this.dialog?.open) this.showError(error.message);
      } finally {
        this.busy = false;
        if (this.queued) { this.queued = false; this.schedule(); }
      }
    }

    plain(value) {
      return new DOMParser().parseFromString(String(value || ''), 'text/html').body.textContent.trim();
    }

    format(cents) { return this.money.format(cents / 100); }

    render() {
      const maximum = this.steps[this.steps.length - 1]?.goal || 1;
      const percent = Math.min(100, Math.max(0, this.cart.total_price / maximum * 100));
      for (const element of this.elements) {
        if (!element.isConnected) { this.elements.delete(element); continue; }
        const status = element.querySelector('[data-oa-rewards-status]');
        const markers = element.querySelector('[data-oa-rewards-markers]');
        const actions = element.querySelector('[data-oa-rewards-actions]');
        if (!status || !markers || !actions) continue;
        status.replaceChildren(); markers.replaceChildren(); actions.replaceChildren();
        for (const step of this.currentStates) {
          // Construire un seul message pour l'ensemble des paliers.
if (status.childElementCount === 0) {
  const clean = (text) =>
    this.plain(text).replace(/[.!?]+$/, '').trim();

  const reachedMessages = this.currentStates
    .filter((state) => state.eligible)
    .map((state) => {
      if (state.isGift && state.picked) {
        return 'Votre cadeau est déjà dans le panier';
      }

      return clean(state.reached) ||
        (state.isGift
          ? 'Votre cadeau vous attend'
          : 'Palier atteint');
    });

  const remainingMessages = this.currentStates
    .filter((state) => !state.eligible)
    .map((state) => {
      const amount = this.format(
        state.goal - this.cart.total_price
      );

      const benefit = clean(state.hook || state.gift) ||
        'cet avantage';

      return `${amount} pour ${benefit}`;
    });

  const phrases = [...reachedMessages];

  if (remainingMessages.length) {
    phrases.push(
      `Encore ${remainingMessages.join(' et ')}`
    );
  }

  const message = document.createElement('p');
  message.className = 'oa-cart-rewards__message';
  message.textContent = `${phrases.join(' · ')}.`;

  status.appendChild(message);
}
          const marker = document.createElement('span');
          marker.className = 'oa-cart-rewards__marker';
          marker.dataset.reached = String(step.eligible);
          marker.style.left = `${Math.min(100, step.goal / maximum * 100)}%`;
          marker.textContent = this.format(step.goal);
          markers.appendChild(marker);
          if (step.isGift && step.eligible && !step.picked) {
            const button = document.createElement('button');
            button.type = 'button'; button.className = 'oa-reward-button';
            button.textContent = step.gift ? `Choisir : ${this.plain(step.gift)}` : 'Choisir mon cadeau';
            button.addEventListener('click', () => this.schedule(step.id));
            actions.appendChild(button);
          }
        }
        const bar = element.querySelector('[data-oa-rewards-bar]');
        if (bar) { bar.style.width = `${percent}%`; bar.parentElement.setAttribute('aria-valuenow', String(Math.round(percent))); }
      }
    }

    ensureDialog() {
      if (this.dialog) return;
      this.dialog = document.createElement('dialog');
      this.dialog.className = 'oa-reward-dialog';
      this.dialog.setAttribute('aria-labelledby', 'oa-reward-dialog-title');
      this.dialog.innerHTML = `
        <div class="oa-reward-dialog__top">
          <p class="oa-reward-dialog__eyebrow">Votre cadeau Oleassence</p>
          <button type="button" class="oa-reward-dialog__close" aria-label="Fermer la fenêtre">×</button>
        </div>
        <h2 class="oa-reward-dialog__title" id="oa-reward-dialog-title">Choisissez votre cadeau</h2>
        <p class="oa-reward-dialog__intro"></p>
        <div data-oa-dialog-content></div>
        <p class="oa-reward-dialog__error" role="alert" hidden></p>
        <p class="oa-reward-dialog__note">Un cadeau au choix pour ce palier, selon les conditions de l’offre.</p>`;
      this.dialog.querySelector('.oa-reward-dialog__close').addEventListener('click', () => this.close(true));
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close(true); });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right ||
              event.clientY < box.top || event.clientY > box.bottom) this.close(true);
          return;
        }
        const button = event.target.closest?.('[data-oa-add-gift]');
        if (button) { event.preventDefault(); this.addGift(button); }
      });
      document.body.appendChild(this.dialog);
    }

    open(step) {
      let template;
      for (const element of this.elements) {
        if (!element.isConnected) continue;
        template = Array.from(element.querySelectorAll('[data-oa-gift-template]'))
          .find((candidate) => candidate.dataset.oaGiftTemplate === step.id);
        if (template) break;
      }
      if (!template) return;
      this.ensureDialog();
      this.openStepId = step.id;
      this.dialog.querySelector('[data-oa-dialog-content]').replaceChildren(template.content.cloneNode(true));
      this.dialog.querySelector('.oa-reward-dialog__intro').textContent =
        this.plain(step.reached) || `Votre panier a atteint ${this.format(step.goal)}. Choisissez votre cadeau ci-dessous.`;
      this.showError('');
      if (!this.dialog.open) this.dialog.showModal();
    }

    close(userDismissed) {
      if (this.adding && userDismissed) return;
      if (userDismissed && this.openStepId) this.dismissed.add(this.openStepId);
      if (this.dialog?.open) this.dialog.close();
      this.openStepId = null;
    }

    showError(message) {
      const output = this.dialog?.querySelector('.oa-reward-dialog__error');
      if (output) { output.textContent = message; output.hidden = !message; }
    }

    async addGift(button) {
      if (button.disabled || this.adding) return;
      const step = this.steps.find((candidate) => candidate.id === this.openStepId);
      if (!step) return;
      const card = button.closest('[data-oa-product]');
      const variantId = card.querySelector('[data-oa-gift-variant]')?.value || button.dataset.variantId;
      if (!step.products.some((product) => product.variants.includes(String(variantId)))) {
        this.showError('Ce format ne fait pas partie des cadeaux disponibles.'); return;
      }
      this.adding = true;
      const buttons = Array.from(this.dialog.querySelectorAll('[data-oa-add-gift]'));
      const previous = buttons.map((item) => item.disabled);
      const label = button.querySelector('span');
      const text = label?.textContent;
      buttons.forEach((item) => { item.disabled = true; });
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Ajout en cours…';
      this.showError('');
      try {
        const cart = await this.request('cart.js');
        const state = this.states(cart).find((candidate) => candidate.id === step.id);
        if (!state?.eligible) throw new Error('Le montant du panier ne permet plus de bénéficier de ce cadeau.');
        if (state.picked) { this.close(false); return; }
        const result = await this.request('cart/add.js', {
          items: [{ id: variantId, quantity: 1, properties: { type: this.giftLabel, _oa_reward_step: step.id } }],
          ...this.sections(),
        });
        this.close(false);
        this.updateTheme(result);
      } catch (error) {
        this.showError(error.message);
      } finally {
        this.adding = false;
        buttons.forEach((item, index) => { item.disabled = previous[index]; });
        button.removeAttribute('aria-busy');
        if (label) label.textContent = text;
        this.schedule();
      }
    }
  }

  const controller = new RewardsController();
  window.OleassenceCartRewardsV3 = controller;
  class CartGamification extends HTMLElement {
    connectedCallback() { controller.register(this); }
    disconnectedCallback() { controller.elements.delete(this); }
  }
  if (!customElements.get('cart-gamification')) customElements.define('cart-gamification', CartGamification);
})();
